import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import MikeTooltip from '@mike/mike-shared-frontend/mike-tooltip/MikeTooltip'

const StyledLongText = styled('div')({
  maxWidth: '25vw',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'table-cell',
  paddingRight: 8
})

const LongText = ({ longText }) => {
  return (
    <MikeTooltip title={longText}>
      <StyledLongText>{longText}</StyledLongText>
    </MikeTooltip>
  )
}

LongText.propTypes = {
  longText: PropTypes.string
}

export default React.memo(LongText)
